import { Box, Text } from "@chakra-ui/layout";
import { useToken } from "@chakra-ui/system";
import { percent } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import {
  Cell,
  Pie,
  PieChart,
  type PieProps,
  ResponsiveContainer,
  Tooltip,
  type TooltipProps,
} from "recharts";
import { getFillColor } from "../utils";

export type PieGraphProps = {
  data: Array<{ name: string; value: number }>;
  outerRadius?: PieProps["outerRadius"];
  innerRadius?: PieProps["innerRadius"];
};

const CustomTooltipContent = ({
  payload,
  active,
}: TooltipProps<number, string>) => {
  if (!active || !payload) return null;
  return (
    <Box
      p="2"
      borderRadius="sm"
      bg="white"
      zIndex="toast"
      border="1px"
      borderColor="gray.300"
    >
      {payload.map((load, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: Payload has no unique identifier
        <Text key={index}>
          <Text fontWeight="bold">{load?.name ?? ""}</Text>
          {percent.format(load?.value ?? 0)}
        </Text>
      ))}
    </Box>
  );
};

export const PieGraph = observer(function PieGraph({
  data,
  outerRadius = 42.5,
  innerRadius = 15,
}: PieGraphProps) {
  const colors = useToken("colors", [
    "riptide.600",
    "riptide.500",
    "riptide.400",
    "riptide.300",
    "riptide.200",
    "riptide.100",
  ]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Tooltip content={CustomTooltipContent} />
        <Pie
          dataKey="value"
          data={data}
          outerRadius={outerRadius}
          innerRadius={innerRadius}
        >
          {data.map((_, index) => (
            <Cell
              // biome-ignore lint/suspicious/noArrayIndexKey: Cell has no unique identifier
              key={`client-share-cell-${index}`}
              fill={getFillColor(colors, index)}
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
});
